import { ChangeDetectorRef, Component } from '@angular/core';
import { LabelledTextBoxComponent, NTSTranslatePipe } from '@nts/std';
import { ModalComponentInterface } from '@nts/std/interfaces';
import { SupplierNotSavedViewModel } from 'src/app/receipt-long-op/view-models/modals/supplier-not-saved.view-model';

@Component({
  selector: 'nts-supplier-not-saved-modal-container',
  templateUrl: 'supplier-not-saved-modal-container.component.html',
  styleUrls: ['./supplier-not-saved-modal-container.component.scss'],
  standalone: true,
  imports: [
    NTSTranslatePipe,
    LabelledTextBoxComponent
  ]
})
export class SupplierNotSavedModalContainerComponent implements ModalComponentInterface {

  /**
   * The view model
   */
  viewModel: SupplierNotSavedViewModel;

  constructor(
    private cd: ChangeDetectorRef,
  ) {

  }

  /**
   * Initialize the component
   */
  async initialize(): Promise<void> {
    await this.viewModel.initialize(this.cd);

    this.cd.detectChanges();
  }
}
